module.exports = __webpack_public_path__ + "img/select-case.8c9d4b83.jpg";